// extracted by mini-css-extract-plugin
export default {"clientLogoContainer":"Logo_clientLogoContainer__aQzJL"};